import { getChildrenOfRoomAndScene, getRoomDimensionsFromLegacyComponents, } from "./RoomHierarchyUtils";
import { snapEntitiesToClosestPlace } from "./SnapBackUtils";
/**
 * Contains utility functions that can be used to handle room related things
 * when serializing and deserializing the core state.
 */
export var SerializationUtils = {
    getRoomDimensionsFromLegacyComponents: getRoomDimensionsFromLegacyComponents,
    getChildrenOfRoomAndScene: getChildrenOfRoomAndScene,
    snapEntitiesToClosestPlace: snapEntitiesToClosestPlace,
};
//# sourceMappingURL=SerializationUtils.js.map